import { useTranslation } from "react-i18next";
import { DEFAULT_LOCALE, LOCALES, type Locale } from "../../../contract/auth";

/** The Interface Language i18next resolved, as a Locale; the format helpers turn it into a BCP 47 tag. */
export function useInterfaceLocale(): Locale {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage ?? i18n.language;
  return (LOCALES as readonly string[]).includes(lang) ? (lang as Locale) : DEFAULT_LOCALE;
}
